import React, { useEffect, useState } from 'react';
import { api, errText } from '../api.js';

const LABELS = {
  qr_ordering: 'QR menü ve sipariş',
  table_management: 'Masa yönetimi',
  open_table: 'Açık hesap modu',
  online_payments: 'Online ödeme',
  split_payments: 'Bölünmüş ödeme',
  kitchen_printing: 'Mutfak yazdırma',
  multi_printer: 'Çoklu yazıcı',
  loyalty: 'Müşteri sadakati',
  analytics_basic: 'Temel analitik',
  analytics_advanced: 'Gelişmiş analitik',
  ai_assistant: 'AI asistanı (aylık mesaj)',
  waiter_call: 'Garson çağır',
  max_tables: 'Masa sınırı (sayı)',
};
const CURRENCIES = ['CHF', 'EUR'];

export default function AdminPlans() {
  const [data, setData] = useState(null);
  const [countries, setCountries] = useState([]);
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState('');

  const load = () => api('/api/admin/plans').then(setData).catch((e) => setErr(errText(e)));
  useEffect(() => {
    load();
    // Ülke listesi country_config'ten gelir: panelde serbest metin ülke kodu
    // YAZILAMAZ, yoksa "CHE" gibi bir yazım hatası sessizce etkisiz satır olur.
    api('/api/admin/countries').then(setCountries).catch(() => {});
  }, []);

  /** Fiyat kutusu TUTARI KURUŞ cinsinden gönderir: 49.90 → 4990. */
  async function savePrice(planId, currency, text) {
    setErr(''); setMsg('');
    const n = Number(String(text).replace(',', '.'));
    if (!Number.isFinite(n) || n < 0) return setErr('Geçersiz tutar');
    const amountMinor = Math.round(n * 100);
    try {
      await api(`/api/admin/plans/${planId}/prices`, {
        method: 'PUT',
        body: { currency, interval: 'MONTH', amountMinor },
      });
      setMsg(`${currency} fiyatı kaydedildi`);
      load();
    } catch (e) {
      setErr(errText(e));
    }
  }

  /** Panel yüzde yazar (3.5), sunucuya TEMEL PUAN gider (350). Float yok. */
  async function saveCommission(planId, text) {
    setErr(''); setMsg('');
    const n = Number(String(text).replace(',', '.'));
    if (!Number.isFinite(n) || n < 0 || n > 100) return setErr('Oran 0 ile 100 arasında olmalı');
    const bps = Math.round(n * 100);
    try {
      await api(`/api/admin/plans/${planId}`, { method: 'PATCH', body: { commissionBps: bps } });
      setMsg(`Komisyon %${(bps / 100).toFixed(2)} olarak kaydedildi`);
      load();
    } catch (e) {
      setErr(errText(e));
    }
  }

  /**
   * Ülkeye özel oran. Boş kutu = oranı KALDIR (paket temel oranına döner).
   * Panel yüzde yazar, sunucuya temel puan gider.
   */
  async function saveCountryCommission(planId, country, text) {
    setErr(''); setMsg('');
    const raw = String(text).trim();
    try {
      if (raw === '') {
        await api(`/api/admin/plans/${planId}/commission/${country}`, { method: 'DELETE' });
        setMsg(`${country} oranı kaldırıldı → paket temel oranı geçerli`);
      } else {
        const n = Number(raw.replace(',', '.'));
        if (!Number.isFinite(n) || n < 0 || n > 100) return setErr('Oran 0 ile 100 arasında olmalı');
        await api(`/api/admin/plans/${planId}/commission/${country}`, {
          method: 'PUT', body: { commissionBps: Math.round(n * 100) },
        });
        setMsg(`${country} oranı %${n.toFixed(2)} olarak kaydedildi`);
      }
      load();
    } catch (e) {
      setErr(errText(e));
    }
  }

  async function saveFeature(planId, featureKey, patch) {
    setErr(''); setMsg('');
    try {
      await api(`/api/admin/plans/${planId}/features`, {
        method: 'PUT',
        body: { features: [{ featureKey, ...patch }] },
      });
      load();
    } catch (e) {
      setErr(errText(e));
    }
  }

  if (err && !data) return <p className="err">{err}</p>;
  if (!data) return <p className="muted">yükleniyor…</p>;

  return (
    <>
      <div className="card">
        <h2>Ücretlendirme</h2>
        <p className="muted" style={{ marginTop: 0 }}>
          İki model bir arada: <b>online ödemesi olmayan</b> pakette sabit aylık ücret,
          online ödemeli paketlerde aylık 0 ve gelir <b>komisyon</b>. Komisyon yalnız
          Stripe'tan geçen tutardan alınır, <b>bahşiş hariç</b>; nakit komisyonsuzdur.
          CHF ve EUR <b>birbirinden bağımsız</b> satırlardır. Oran temel puan olarak
          saklanır (%3 = 300), float yoktur.
        </p>
        <table>
          <thead>
            <tr>
              <th>Paket</th>
              {CURRENCIES.map((c) => <th key={c}>{c} / ay</th>)}
              <th style={{ width: 120 }}>Komisyon %</th>
              <th>Model</th>
            </tr>
          </thead>
          <tbody>
            {data.plans.map((p) => (
              <tr key={p.id}>
                <td><b>{p.name}</b><div className="muted">{p.key}</div></td>
                {CURRENCIES.map((c) => {
                  const pr = p.prices.find((x) => x.currency === c && x.interval === 'MONTH');
                  return (
                    <td key={c} style={{ width: 140 }}>
                      <input
                        defaultValue={pr ? (pr.amountMinor / 100).toFixed(2) : ''}
                        placeholder="49.00"
                        onBlur={(e) => {
                          const cur = pr ? (pr.amountMinor / 100).toFixed(2) : '';
                          if (e.target.value !== cur) savePrice(p.id, c, e.target.value);
                        }}
                      />
                    </td>
                  );
                })}
                <td>
                  <input
                    defaultValue={(p.commissionBps / 100).toFixed(2)}
                    placeholder="3.00"
                    onBlur={(e) => {
                      const cur = (p.commissionBps / 100).toFixed(2);
                      if (e.target.value === cur) return;
                      saveCommission(p.id, e.target.value);
                    }}
                  />
                </td>
                <td className="muted" style={{ fontSize: 12 }}>
                  {/* Hem aylık ücret hem komisyon tanımlıysa bu KARMA bir pakettir;
                      "komisyon" yazmak restoranın ne ödediğini yanlış gösterirdi. */}
                  {(() => {
                    const monthly = p.prices.some((x) => x.amountMinor > 0);
                    if (p.commissionBps > 0 && monthly) return <span className="badge warn">karma (aylık + komisyon)</span>;
                    if (p.commissionBps > 0) return <span className="badge warn">komisyon</span>;
                    if (monthly) return <span className="badge ok">sabit aylık</span>;
                    return <span className="badge bad">ücretsiz</span>;
                  })()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="card">
        <h2>Ülkeye özel komisyon</h2>
        <p className="muted" style={{ marginTop: 0 }}>
          Bir ülkede yazılan oran, paketin <b>temel oranını ezer</b>. Gerekçe: İsviçre'de
          kart kabul maliyeti eurozone'dan belirgin yüksek (Stripe CH ~%2,9 + 0,30 CHF,
          EU kartı ~%1,5 + 0,25 €) — tek oran CH'de platform payını eritir, eurozone'da
          gereksiz pahalı görünür. <b>Boş kutu</b> = o ülkede temel oran geçerli.
          Restoran bazındaki pazarlık bundan ayrıdır ve <b>bunu da yener</b>
          (Restoranlar ekranı).
        </p>
        <table>
          <thead>
            <tr>
              <th>Ülke</th>
              {data.plans.map((p) => (
                <th key={p.id} style={{ width: 130 }}>
                  {p.name}
                  <div className="muted" style={{ fontWeight: 400 }}>
                    temel %{(p.commissionBps / 100).toFixed(2)}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {countries.map((c) => (
              <tr key={c.country}>
                <td>
                  <b>{c.country}</b> <span className="muted">{c.currency}</span>
                  {!c.available && <span className="badge bad" style={{ marginLeft: 6 }}>kapalı</span>}
                </td>
                {data.plans.map((p) => {
                  const row = (p.countryCommissions || []).find((x) => x.country === c.country);
                  const cur = row ? (row.commissionBps / 100).toFixed(2) : '';
                  return (
                    <td key={p.id}>
                      <input
                        defaultValue={cur}
                        placeholder={`temel ${(p.commissionBps / 100).toFixed(2)}`}
                        onBlur={(e) => {
                          if (e.target.value.trim() === cur) return;
                          saveCountryCommission(p.id, c.country, e.target.value);
                        }}
                      />
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="card">
        <h2>Özellik matrisi</h2>
        <p className="muted" style={{ marginTop: 0 }}>
          Kodda paket adı sorgulanmaz; kapılar yalnız bu matrisi okur. Değişiklik
          en çok 60 saniyede tüm uçlara yansır.
        </p>
        <div style={{ overflowX: 'auto' }}>
          <table>
            <thead>
              <tr><th>Özellik</th>{data.plans.map((p) => <th key={p.id}>{p.name}</th>)}</tr>
            </thead>
            <tbody>
              {data.featureKeys.map((key) => (
                <tr key={key}>
                  <td>{LABELS[key] || key}</td>
                  {data.plans.map((p) => {
                    const f = p.features.find((x) => x.featureKey === key);
                    const enabled = !!f?.enabled;
                    return (
                      <td key={p.id}>
                        <div className="switch">
                          <input type="checkbox" checked={enabled}
                            onChange={(e) => saveFeature(p.id, key, { enabled: e.target.checked, limitInt: f?.limitInt ?? null })} />
                          {key === 'max_tables' && enabled && (
                            <input style={{ width: 90 }} placeholder="sınırsız"
                              defaultValue={f?.limitInt ?? ''}
                              onBlur={(e) => {
                                const raw = e.target.value.trim();
                                const limitInt = raw === '' ? null : Number(raw);
                                if (raw !== '' && !Number.isInteger(limitInt)) return setErr('Sınır tam sayı olmalı');
                                if ((f?.limitInt ?? null) !== limitInt) saveFeature(p.id, key, { enabled: true, limitInt });
                              }} />
                          )}
                        </div>
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {msg && <p className="ok">{msg}</p>}
      {err && <p className="err">{err}</p>}
    </>
  );
}
